export default __webpack_public_path__ + "static/media/tour3.80c8e920.png";